import {
  REQUEST_AGENCY,
  RECEIVE_AGENCY,
  REQUEST_AGENCY_FAILURE
} from '../actions/agency'

const agency = (state = {
  isFetching: false,
  agencyId: null,
  details: {}
}, action) => {
  switch (action.type) {
    case REQUEST_AGENCY:
      return Object.assign({}, state, {
        isFetching: true,
        agencyId: action.agencyId
      })
    case RECEIVE_AGENCY:
      console.log('[agency reducer] RECEIVE_AGENCY payload (details):', action.details);
      return Object.assign({}, state, {
        isFetching: false,
        details: action.details,
        lastUpdated: action.receivedAt
      })
    case REQUEST_AGENCY_FAILURE:
      console.error('[agency reducer] REQUEST_AGENCY_FAILURE:', action.error);
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error?.message || String(action.error) // fixed to not get the nonerialzed errir
      })
    default:
      return state
  }
}

export default agency
